import { BaseApiManager, ApiResponse } from './BaseApiManager';

export class ChatApiManager extends BaseApiManager {
  private static instance: ChatApiManager;

  private constructor() {
    super();
  }

  public static getInstance(): ChatApiManager {
    if (!ChatApiManager.instance) {
      ChatApiManager.instance = new ChatApiManager();
    }
    return ChatApiManager.instance;
  }

  public async startChat(userId: string | number, categoryPrompt: string): Promise<ApiResponse<any>> {
    return this.request('/core/chat/start', {
      method: 'POST',
      body: JSON.stringify({ userId, categoryPrompt }),
    });
  }

  public async continueChat(sessionId: string, userMessage: string, categoryPrompt: string): Promise<ApiResponse<any>> {
    return this.request('/core/chat/continue', {
      method: 'POST',
      body: JSON.stringify({ sessionId, userMessage, categoryPrompt }),
    });
  }

  public async generateVisualization(userId: string | number, sessionId: string | number): Promise<ApiResponse<Array<{ index: number; url: string | null; status: 'ok' | 'failed'; }>>> {
    // Set a longer timeout for session generation (5 minutes)
    this.setRequestTimeout(300000); // 5 minutes in milliseconds
    
    const result = await this.request<Array<{ index: number; url: string | null; status: 'ok' | 'failed'; }>>('/core/chat/GenerateSession', {
      method: 'POST',
      body: JSON.stringify({ 
        sessionId: Number(sessionId), // Convert to number
        userId: String(userId)       // Ensure string
      }),
    });
    
    // Reset timeout to default after the request
    this.setRequestTimeout(30000); // Reset to 30 seconds
    
    return result;
  }
}
